import Vue from "vue";
import Vuex from "vuex";

import { userState } from "./users";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        user: userState
    }
});
